export enum TrackingAvcStep {
    SHOW = 'show',
    START = 'start',
    COMPLETE = 'complete'
}

export enum TrackingProductType {
    KDG = 'cable',
    UME = 'cable (unity)',
    DSL = 'dsl',
    FIBER = 'fiber'
}

export enum AccessSupplierType {
    VFDE = 'VFDE',
    OXG = 'OXGG',
    DTAG = 'DTAG',
    DGW = 'DGW'
}
